import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useTranslate } from '@tolgee/react';
import PrimaryButton from "../GenericComponents/PrimaryButton";

const InfoModal = ({ openModal, infoType }) => {
  const { t } = useTranslate();
  let description = (
    <>
      <p>{t('onboardingPage.cultural_bg_intro')}</p>
      <ul style={{ padding: "0 10px 0 20px" }}>
        <li>{t('onboardingPage.cultural_bg_item1')}</li>
        <li>{t('onboardingPage.cultural_bg_item2')}</li>
        <li>{t('onboardingPage.cultural_bg_item3')}</li>
        <li>{t('onboardingPage.cultural_bg_item4')}</li>
      </ul>
      <p>{t('onboardingPage.cultural_bg_info')}</p>
    </>
  );
  let header = <h5>{t('profile.cultural_background')}</h5>;

  switch (infoType) {
    case "culturat":
      description = (
        <>
          <p>{t('onboardingPage.cultural_bg_intro')}</p>
          <ul style={{ padding: "0 10px 0 20px" }}>
            <li>{t('onboardingPage.cultural_bg_item1')}</li>
            <li>{t('onboardingPage.cultural_bg_item2')}</li>
            <li>{t('onboardingPage.cultural_bg_item3')}</li>
            <li>{t('onboardingPage.cultural_bg_item4')}</li>
          </ul>
          <p> {t('onboardingPage.cultural_bg_info')}</p>
        </>
      );
      header = <h5>{t('profile.cultural_background')}</h5>;
      break;
    case "details":
      description = (
        <>
          <p>{t('info_modal.intro')}</p>
          <ul style={{ padding: "0 10px 0 20px" }}>
            <li>{t('info_modal.info_item1')}</li>
            <li>{t('info_modal.info_item2')}</li>
          </ul>
          <p>{t('info_modal.info1')}</p>
          <p>{t('info_modal.info2')}</p>
        </>
      );
      header = <h5>{t('general.details')}</h5>;
      break;

    case "link_phone":
      description = (
        <>
          <p>{t('info_modal.link_phone_text')}</p>
        </>
      );
      header = <h5>{t('info_modal.link_phone_details')}</h5>;
      break;

    default:
      break;
  }
  const openWebApp = () => {
    if (
      window.electron &&
      typeof window.electron.openExternalUrl === "function"
    ) {
      window.electron.openExternalUrl("https://app.emotii.ai");
      openModal()
    } else {
      console.error("Electron API is not available or function not defined");
    }
  }
  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        // 👇️ your logic here
        openModal();
      }
    };

    document.addEventListener("keydown", keyDownHandler);

    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, []);
  return (
    <FullScreenItem>
      <Container>
        <Header>{header}</Header>
        <Description>{description}</Description>
        {infoType === "link_phone" &&

          <PrimaryButton
            onClick={() => openWebApp()}
            style={{ padding: "16px" }}
            text={t('info_modal.link_phone_open_web')}
          />}

        <CloseBtn onClick={openModal}>
          {t('general.close')}
        </CloseBtn>
      </Container>
    </FullScreenItem>
  );
};

export default InfoModal;

const FullScreenItem = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  width: 100%;
  height: 100%;
  display: flex;
  padding: 20px;
  justify-content: center;
  align-items: center;
  z-index: 3;
  overflow: hidden;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 25px;
  max-height: 100%;
  width: 400px;
  background: ${({ theme }) => theme.menu.groupContentBackground};
  gap: 20px;
  border-radius: 4px;
  overflow: auto;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  h5 {
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    color: ${({ theme }) => theme.menu.secondaryTextColor};
  }
`;

const CloseBtn = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme.primaryButton.color};
  font-size: 18px;
  lin-height: 16px;
  margin-left: auto;
  margin-right: auto;
`;

const Description = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 18px;
  white-space: pre-wrap;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  gap: 15px;
  display: flex;
  flex-direction: column;
`;
